import { RefreshCw } from 'lucide-react';
import { useVersionCheck } from '@/hooks/useVersionCheck';

/**
 * Slim bar shown above the header when a newer build has been deployed. Lets the
 * user reload on their own terms rather than being interrupted by a forced
 * refresh — important for warehouse flows mid-scan. Renders nothing when the
 * running build is current.
 */
export function UpdateBanner() {
  const updateAvailable = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-3 bg-primary px-4 py-2 text-sm text-primary-foreground"
    >
      <span>A new version of WMS Pro is available.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="inline-flex items-center gap-1.5 rounded-md bg-primary-foreground/15 px-3 py-1 font-medium transition-colors hover:bg-primary-foreground/25"
      >
        <RefreshCw className="h-3.5 w-3.5" />
        Reload
      </button>
    </div>
  );
}
